/* eslint-disable @typescript-eslint/no-require-imports */
require("smoothscroll-polyfill").polyfill()

import "@/helpers/turbo"
import { application } from "../helpers/stimulus"

import "@/styles/venues.scss"

import { setupTabs } from "@/components/tabs"
import { setupAccordions } from "@/components/content/Accordion"

import CarouselController from "../controllers/carousel_controller"
import ClearableInputController from "../controllers/clearable_input_controller"
import CounterController from "../controllers/counter_controller"
import DialogController from "../controllers/dialog_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import DrawerController from "../controllers/drawer_controller"
import DrawerGroupController from "../controllers/drawer_group_controller"
import LoaderController from "../controllers/loader_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import TabsController from "../controllers/tabs_controller"
import TooltipController from "../controllers/tooltip_controller"
import TurboFrameMissingController from "../controllers/turbo_frame_missing_controller"
import WindowNavigationController from "../controllers/window_navigation_controller"

import ErrorTrackingController from "../controllers/tracking/error_tracking_controller"

import BookingCalendarController from "../controllers/venue/booking_calendar_controller"
import BookingFooterController from "../controllers/venue/booking_footer_controller"
import VenueCarouselController from "../controllers/venue/carousel_controller"
import MonetaryVoucherController from "../controllers/venue/monetary_voucher_controller"
import PackageBookingController from "../controllers/venue/package_booking_controller"
import PackageDetailsModalController from "../controllers/venue/package_details_modal_controller"
import PackageVoucherController from "../controllers/venue/package_voucher_controller"
import PackageController from "../controllers/venue/package_controller"
import PackagesController from "../controllers/venue/packages_controller"
import NewPackagesController from "../controllers/venue/packages_controller_new"
import RoomCounterController from "../controllers/venue/room_counter_controller"
import ScrollspyController from "../controllers/venue/scrollspy_controller"
import SearchDateController from "../controllers/venue/search_date_controller"
import SearchGuestsController from "../controllers/venue/search_guests_controller"
import SearchModalController from "../controllers/venue/search_modal_controller"
import VoucherFooterController from "../controllers/venue/voucher_footer_controller"
import ReviewsController from "../controllers/venue/reviews_controller"

import { loadBackgroundImages } from "@/helpers/image_loader"
import { trackVisit } from "@/helpers/visit_tracker"

const NEW_PACKAGES = document.body.getAttribute("data-new-packages") === "true"

const setupStimulus = (): void => {
  application.register("about-venue-modal", ModalController)
  application.register("about-venue-modal-trigger", ModalTriggerController)
  application.register("booking-calendar", BookingCalendarController)
  application.register("booking-footer", BookingFooterController)
  application.register("booking-modal", ModalController)
  application.register("carousel", CarouselController)
  application.register("clearable-input", ClearableInputController)
  application.register("dialog", DialogController)
  application.register("disclosure-item", DisclosureItemController)
  application.register("drawer", DrawerController)
  application.register("drawer-group", DrawerGroupController)
  application.register("error-tracking", ErrorTrackingController)
  application.register("hero-modal", ModalController)
  application.register("hero-modal-trigger", ModalTriggerController)
  application.register("loader", LoaderController)
  application.register("monetary-voucher", MonetaryVoucherController)
  application.register("monetary-voucher-modal", ModalController)
  application.register("package-booking", PackageBookingController)
  application.register("package-voucher", PackageVoucherController)
  application.register("package-voucher-modal", ModalController)
  application.register("page-loader", LoaderController)
  application.register("pax-counter", CounterController)
  application.register("room-counter", RoomCounterController)
  application.register("reviews", ReviewsController)
  application.register("scrollspy", ScrollspyController)
  application.register("tabs", TabsController)
  application.register("tooltip", TooltipController)
  application.register("turbo-frame-missing", TurboFrameMissingController)
  application.register("venue-carousel", VenueCarouselController)
  application.register("voucher-footer", VoucherFooterController)
  application.register("window-navigation", WindowNavigationController)

  if (NEW_PACKAGES) {
    application.register("guests-counter", CounterController)
    application.register("package-details-modal", PackageDetailsModalController)
    application.register("search-date", SearchDateController)
    application.register("search-guests", SearchGuestsController)
    application.register("search-modal", SearchModalController)
    application.register("search-modal-trigger", ModalTriggerController)
    application.register("venue-package", PackageController)
    application.register("venue-packages", NewPackagesController)
  } else {
    application.register("venue-packages", PackagesController)
  }
}

setupStimulus()
loadBackgroundImages()
setupTabs()
setupAccordions()
void trackVisit("/venue_visit")
